import { BeneficiaryAdditionalInfoDetails } from './beneficiaryAdditionalInfoDetails';

export default BeneficiaryAdditionalInfoDetails;